<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ "actions.updateCampaign" | translate }}
    </h4>
    <h5 class="m-b-0 m-t-10">
      {{ companyName }}
    </h5>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <span
    class="d-flex text-wrap mb-2 align-items-baseline"
    [ngClass]="'badge badge-light-warning'"
    *ngIf="availabilityStatus === locationAvailabilityEnum.PARTIALLY"
  >
    <i class="icofont icofont-info-circle"></i>
    <p class="lh-base text-start m-0 px-2">
      {{ "updateAvailability.locationLabel" | translate }}
      {{ "updateAvailability.reservedNotice" | translate }}
      <b>{{ "updateAvailability.specificPeriods" | translate }}</b
      >.
      {{ "updateAvailability.selectDifferentDates" | translate }}
    </p>
  </span>

  <span
    class="d-flex text-wrap m-0 align-items-baseline"
    [ngClass]="'badge badge-light-warning'"
    *ngIf="
      availabilityStatus === locationAvailabilityEnum.PARTIALLY_BOOKED ||
      availableDatesNotBooked.length > 0
    "
  >
    <i class="icofont icofont-info-circle"></i>

    <p class="lh-base text-start m-0 px-2">
      {{
        "updateAvailability.availableButNotFullyBooked.locationLabel"
          | translate
      }}
      <b>{{
        "updateAvailability.availableButNotFullyBooked.notReserved"
          | translate
      }}</b>
      {{
        "updateAvailability.availableButNotFullyBooked.allDays"
          | translate
      }}
    </p>
  </span>

  <div class="mb-2 mt-3 blue-color fw-semibold">
    <b>{{ "updateAvailability.newPeriodRequest" | translate }}</b>
  </div>
  <div class="cal-date-widget card-body">
    <div class="cal-datepicker">
      <ngb-datepicker
        [(ngModel)]="model"
        (navigate)="date = $event.next"
        (dateSelect)="onDateSelect($event)"
        [dayTemplate]="customDay"
        outsideDays="visible"
        [markDisabled]="isDateDisabled"
      >
      </ngb-datepicker>

      <ng-template #customDay let-date let-currentMonth="currentMonth">
        <span
          class="custom-day"
          [class.badge-light-danger]="isUnavailable(date)"
          [class.badge-light-success]="isAvailable(date)"
          [class.text-muted]="date.month !== currentMonth"
        >
          {{ date.day }}
        </span>
      </ng-template>
    </div>
  </div>
</div>
<div class="modal-footer justify-content-between">
  <a
    class="txt-danger text-12px"
    (click)="showDeleteModal()"
    style="cursor: pointer"
  >
    <i class="icofont icofont-trash"></i>
    {{ "buttons.deleteLocation" | translate }}
  </a>
  <div>
    <button
      type="button"
      class="btn btn-outline-primary"
      data-bs-dismiss="modal"
      (click)="close()"
    >
      {{ "buttons.close" | translate }}
    </button>
    <button class="btn btn-primary m-l-10" (click)="update()">
      <loading-button
        [loading]="loading"
        [value]="'buttons.apply'"
        [icon]="null"
      ></loading-button>
    </button>
  </div>
</div>
